import { tephraReg, tephraTagReg } from "./regexp/tephra";
import { includeReg } from "./regexp/include";
import TephraErrors from "./errors";
import convertStringToObject from "./convertStringToObject";

const initialStructure = {
  tephra: false,
  snippet: false,
  secure_random: null,
  hex: null,
  _ref: null,
  reference: null,
  title: null,
  line: "",
  _line: {
    prevLine: "",
    position: null,
    content: ""
  },
  error: false,
  prettyLine: ""
};

export default function(raw) {
  const lines = raw.split("\n");
  const structuredLines = lines.reduce((acc, line, pos) => {
    const _line = {
      position: pos,
      prevLine: acc[pos - 1] ? acc[pos - 1].line : null,
      content: line
    };

    let structured = {
      ...initialStructure,
      line,
      _line
    };
    const isTephraTag = tephraTagReg.test(line);
    const tephraMatch = tephraReg.exec(line);

    if (tephraMatch) {
      const serialized = serializeTephraObject(tephraMatch, _line);
      structured = {
        ...structured,
        ...serialized,
        prettyLine: prettyTephraLine(serialized)
      };
      return acc.concat(structured);
    }

    if (isTephraTag) {
      const errorMsg = TephraErrors.invalidTephraSyntax(_line);
      throw new Error(errorMsg);
      // structured = {
      //   ...structured,
      //   error: errorMsg
      // }
    }
    const includeMatch = includeReg.exec(line);
    if (includeMatch) {
      structured = {
        ...structured,
        ...serializeIncludeObject(includeMatch.groups)
      };
    }
    // structured.fixedLine =
    return acc.concat(structured);
  }, []);
  window.__structuredLines = structuredLines;
  return structuredLines;
}

/**
 * cover the following:
 *  1- comment blocks
 *  2- tephra destruct
 *  3- include tags
 * data structure
 *  {
 *    ignored: Boolean
 *    tephra: Boolean
 *    snippet: Boolean
 *    raw: String
 *  }
 */

function prettyTephraLine(serialized) {
  const { hex, selected_options, reference, content } = serialized;
  if (!reference) return null;
  const LeftWing = safeMatch(content, /.*(?={%\s*tephra)/);
  const RightWing = safeMatch(content, /(?<=}\s*%}).*$/);
  let pretty = LeftWing + `{% tephra '${reference}'`;
  if (selected_options) pretty += `, ${selected_options.__string || stringify(selected_options)}`;
  if (hex) pretty += ` | { hex: '${hex.replace(/'|"/g, "").trim()}' }`;
  return pretty + " %}" + RightWing;
}
function serializeTephraObject(match, line) {
  let { hex, reference, hexHash } = match.groups;
  const selected_options = convertStringToObject(match, line);
  const hasHex = hex && hex.trim().length;
  if (hasHex) {
    hex = `'${hex.replace(/'|"/g, "").trim()}'`;
  }
  if (!hasHex && hexHash) {
    hex = `'${CodeEditor.GUID()}'`;
  }
  const structure = {
    tephra: true,
    hex,
    reference,
    title: reference.split("/")[1],
    selected_options,
    content: line.content
  };
  if (selected_options && selected_options.error) {
    structure.error = selected_options.error;
  }
  return structure;
}

function serializeIncludeObject({ reference }) {
  return {
    snippet: true,
    title: reference.split("/")[1] || reference,
    reference
  };
}

function safeMatch(line, regexp) {
  return (line.match(regexp) || [])[0] || "";
}

function stringify(obj_from_json) {
  if (typeof obj_from_json !== "object" || Array.isArray(obj_from_json)) {
    // not an object, stringify using native function
    return JSON.stringify(obj_from_json);
  }
  // Implements recursive object serialization according to JSON spec
  // but without quotes around the keys.
  let props = Object.keys(obj_from_json)
    .map(key => `${key}: ${stringify(obj_from_json[key])}`)
    .join(", ");
  return `{ ${props} }`;
}
